import { render, staticRenderFns } from "./ItemDropGroup.vue?vue&type=template&id=b4987f64&scoped=true&"
import script from "./ItemDropGroup.vue?vue&type=script&lang=js&"
export * from "./ItemDropGroup.vue?vue&type=script&lang=js&"
import style0 from "./ItemDropGroup.vue?vue&type=style&index=0&id=b4987f64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4987f64",
  null
  
)

export default component.exports